const TRAILING_ZERO_PATTERN = /\.0$/;

export const formatCharacterCountHint = (count: number | null | undefined): string | null => {
  if (typeof count !== 'number' || !Number.isFinite(count) || count <= 0) {
    return null;
  }

  const formatValue = (value: number, unit: 'K' | 'M') => {
    const display = value >= 10 ? Math.round(value).toString() : value.toFixed(1).replace(TRAILING_ZERO_PATTERN, '');
    return `${display}${unit}`;
  };

  if (count >= 1_000_000) {
    return formatValue(count / 1_000_000, 'M');
  }

  if (count >= 1000) {
    return formatValue(count / 1000, 'K');
  }

  return `${Math.round(count)}`;
};
